import { CreateSnippetButton, snippetsModel } from '../../../features/snippets';
import { useSnippetsPermissions } from '../../../features/teams';
import { Button } from '../../../shared/ui';

import { useDispatch, useSelector } from 'react-redux';
import { useSnippetsActions } from '../hooks';

export const SnippetsActions = () => {
  const dispatch = useDispatch();

  const isCreateCategoryLoading = useSelector(
    snippetsModel.selectors.selectIsCreateCategoryLoading
  );

  const { isCanManageCategories } = useSnippetsPermissions();
  const { isCanManageOrCreatePersonalSnippets } = useSnippetsActions();

  const handleClickManageCategories = () => {
    dispatch(snippetsModel.actions.setIsManageCategoriesModalOpen(true));
  };

  return (
    <div className="flex flex-nowrap items-center gap-4 sm:hidden">
      {isCanManageCategories && (
        <Button
          variant="text"
          color="secondary"
          size="md"
          onClick={handleClickManageCategories}
          loading={isCreateCategoryLoading}
          className="font-semibold shadow-xs"
        >
          Manage categories
        </Button>
      )}
      {isCanManageOrCreatePersonalSnippets && <CreateSnippetButton size="md" />}
    </div>
  );
};
